export default __webpack_public_path__ + "static/media/bulb.546bfd17.svg";